import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  listHealthRecords,
  saveHealthAttendance,
  saveHealthRecord,
} from "../../api/healthRecordApi";

export function PrescriptionHealthFields({ grId, players }) {
  const { t } = useTranslation();
  const [playerId, setPlayerId] = useState("");
  const [goal, setGoal] = useState("");
  const [validUntil, setValidUntil] = useState("");
  const [present, setPresent] = useState(true);
  const [loadBand, setLoadBand] = useState("steady");
  const [sessionDate, setSessionDate] = useState("");
  const [recordId, setRecordId] = useState("");
  const [notice, setNotice] = useState("");

  useEffect(() => {
    if (!grId) return undefined;
    let cancelled = false;
    listHealthRecords(grId)
      .then((data) => {
        if (cancelled || !data?.records?.length) return;
        const first = data.records[0];
        setPlayerId(first.player_id || "");
        setGoal(first.functional_goal || "");
        setValidUntil(first.prescription_valid_until || "");
        setRecordId(first.health_record_id || "");
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [grId]);

  if (!grId) return null;

  return (
    <div className="input-detail">
      <label htmlFor="health-player">
        {t("healthFileTitle", "Prescription file (separate from the sport group)")}
      </label>
      <p className="group-form__hint">
        {t(
          "healthFileHint",
          "End date and a functional goal only. No diagnosis. Stored on Google Cloud in the EU, not on a camera computer."
        )}
      </p>
      <select
        id="health-player"
        value={playerId}
        onChange={(event) => setPlayerId(event.target.value)}
      >
        <option value="">{t("player")}</option>
        {(players || []).map((player) => (
          <option key={player.player_id} value={player.player_id}>
            {[player.user_first_name, player.user_last_name].filter(Boolean).join(" ") ||
              player.player_id}
          </option>
        ))}
      </select>
      <input
        type="date"
        value={validUntil || ""}
        onChange={(event) => setValidUntil(event.target.value)}
        aria-label={t("healthValidUntil", "Prescription valid until")}
      />
      <textarea
        maxLength={280}
        rows={3}
        value={goal}
        placeholder={t("healthGoal", "Functional goal")}
        onChange={(event) => setGoal(event.target.value)}
      />
      <button
        type="button"
        onClick={async () => {
          try {
            const saved = await saveHealthRecord({
              gr_id: grId,
              player_id: playerId,
              functional_goal: goal,
              prescription_valid_until: validUntil,
            });
            setRecordId(saved?.health_record_id || "");
            setNotice(t("healthSaved", "Health file saved."));
          } catch (error) {
            setNotice(error.message);
          }
        }}
      >
        {t("healthSave", "Save health file")}
      </button>
      <label htmlFor="health-date">{t("healthAttendance", "Attendance")}</label>
      <input
        id="health-date"
        type="date"
        value={sessionDate}
        onChange={(event) => setSessionDate(event.target.value)}
      />
      <select value={loadBand} onChange={(event) => setLoadBand(event.target.value)}>
        <option value="low">{t("healthLoadLow", "Low load")}</option>
        <option value="steady">{t("healthLoadSteady", "Steady load")}</option>
        <option value="high">{t("healthLoadHigh", "High load")}</option>
      </select>
      <label>
        <input
          type="checkbox"
          checked={present}
          onChange={(event) => setPresent(event.target.checked)}
        />{" "}
        {t("healthPresent", "Present")}
      </label>
      <button
        type="button"
        disabled={!recordId || !sessionDate}
        onClick={async () => {
          try {
            await saveHealthAttendance({
              health_record_id: recordId,
              session_date: sessionDate,
              present,
              load_band: loadBand,
            });
            setNotice(t("healthAttendanceSaved", "Attendance saved."));
          } catch (error) {
            setNotice(error.message);
          }
        }}
      >
        {t("healthSaveAttendance", "Save attendance")}
      </button>
      {notice ? <p className="group-form__hint">{notice}</p> : null}
    </div>
  );
}
